class ConsultaNcm {
    constructor($scope, api) {
        this.apply = fun => $scope.$apply(fun)
        this.api = api

        this.onNcmClick = this.onNcmClick.bind(this)
    }

    $onInit() {
        this.filtro = {
            contrato: this.contratoId,
            exTipi: false,
            ncm: this.ncm ? this.ncm : '',
            tipoPesquisa: 'PALAVRA'
        }

        if (this.ncm) {
            this.promise = this.consultaNcms()
        }
    }

    submit(form) {
        if (form.$valid) {
            this.alertaNcm = null
            this.ncms = null
            this.error = null

            this.promise = this.consultaNcms()
        }
    }

    consultaNcms() {
        const filtro = { ...this.filtro }
        return this.api
            .get('/eficiencia-fiscal/consulta-ncm', filtro)
            .then(({ data: { success, data, message } }) => {
                if (success) {
                    this.ncms = data.items.map(item => this.parseTreeNode(item))
                    this.alertaNcm = data.alertaNcm
                } else {
                    return Promise.reject(message)
                }
            })
            .catch(message => this.error = this.getMessage(message))
    }

    getMessage(code) {
        switch (code) {
            case 'sem_permissao':
                return "Usuário não tem permissão para acessar esta ferramenta."
            default:
                return "Ocorreu um erro ao carregar os dados."
        }
    }

    onNcmClick(ncm) {
        this.onSelect({ ncm })
    }

    parseTreeNode(data) {
        return {
            ...data,
            nodes: data.childs ? data.childs.map(this.parseTreeNode.bind(this)) : null,
            name: `${data.classificacao} - ${data.descricao}${data.vigente ? "" : " (NCM EXPIRADO)"}`
        }
    }
}

angular.module("eficienciaFiscalModule")
    .component("consultaNcm", {
        controller: ['$scope', 'api', ConsultaNcm],
        bindings: {
            onSelect: '&',
            contratoId: '<',
            ncm: '<'
        },
        template: `
        <form name="form" ng-submit="$ctrl.submit(form)" novalidate>
            <promise-tracker promise="$ctrl.promise" active="$ctrl.loading">
                <div class="row clearfix">
                    <div class="form-group col-xs-12 col-md-3">
                        <label>
                            Tipo de busca
                        </label>
                        <select class="form-control" name="tipoPesquisa" ng-model="$ctrl.filtro.tipoPesquisa">
                            <option value="CONTEM">Contém</option>
                            <option value="COMECA">Começa com</option>
                            <option value="IGUAL">Igual a</option>
			    <option value="PALAVRA">Palavra</option>
                        </select>
                        <div 
                            ng-messages="form.tipoPesquisa.$error"
                            ng-messages-multiple="ng-messages-multiple"
                            ng-messages-include="erros-validacao"
                            ng-if="form.$submitted">
                        </div>
                    </div>
                    <div class="form-group col-xs-12 col-md-9">
                        <label>
                            Descrição <i class="text-danger cursor-pointer fa fa-trash-o" ng-show="$ctrl.filtro.descricao" ng-click="$ctrl.filtro.descricao = ''"></i>
                        </label>
                        <input name="descricao" ng-model="$ctrl.filtro.descricao" class="form-control" />
                        <div 
                            ng-messages="form.descricao.$error"
                            ng-messages-multiple="ng-messages-multiple"
                            ng-messages-include="erros-validacao"
                            ng-if="form.$submitted">
                        </div>
                    </div>
                    <div class="form-group col-xs-12 col-md-4">
                        <label>
                            Classificação NCM <i class="text-danger cursor-pointer fa fa-trash-o" ng-show="$ctrl.filtro.ncm" ng-click="$ctrl.filtro.ncm = ''"></i>
                        </label>
                        <input name="ncm" ng-model="$ctrl.filtro.ncm" class="form-control" />
                        <div 
                            ng-messages="form.ncm.$error" 
                            ng-messages-multiple="ng-messages-multiple" 
                            ng-messages-include="erros-validacao"
                            ng-if="form.$submitted">
                        </div>
                    </div>
                    <div class="form-group col-xs-12 col-md-4">
                        <label>
                            Código de barras <i class="text-danger cursor-pointer fa fa-trash-o" ng-show="$ctrl.filtro.codigoBarras" ng-click="$ctrl.filtro.codigoBarras = ''"></i>
                        </label>
                        <input name="codigoBarras" ng-model="$ctrl.filtro.codigoBarras" class="form-control" />
                        <div 
                            ng-messages="form.codigoBarras.$error" 
                            ng-messages-multiple="ng-messages-multiple" 
                            ng-messages-include="erros-validacao"
                            ng-if="form.$submitted">
                        </div>
                    </div>
                    <div class="form-group col-xs-12 col-md-3">
                        <label class="hidden-xs hidden-sm"></label>
                        <div class="checkbox form-horizontal">
                            <label>
                                <input 
                                    name="incluirExpirados" 
                                    ng-model="$ctrl.filtro.incluirExpirados" 
                                    type="checkbox" 
                                    class="checkbox" />
                                
                                <span>Incluir NCMs expirados?</span>
                            </label>
                        </div>
                        
                        <div 
                            ng-messages="form.incluirExpirados.$error" 
                            ng-messages-multiple="ng-messages-multiple"
                            ng-messages-include="erros-validacao" 
                            ng-if="form.$submitted">
                        </div>
                    </div>
  
                    <div class="form-group col-xs-12 col-md-4">
                        <label class="hidden-sm hidden-xs" style="margin-top: 14px"></label>
                        <button type="submit" class="btn btn-primary btn-block btn-sm" ng-disabled="$ctrl.loading">
                            <i class="fa fa-search"></i> Pesquisar
                        </button>
                    </div>

                    <div class="col-xs-12">
                        <loading promise="$ctrl.promise">
                            <div ng-if="$ctrl.ncms.length">
                                <cbk-tree nodes="$ctrl.ncms" on-click="$ctrl.onNcmClick"></cbk-tree>
                            </div>
                            <highlighted ng-if="$ctrl.ncms && !$ctrl.ncms.length">
                                <main>Nenhuma informação encontrada.</main>
                            </highlighted>
                            <highlighted ng-if="$ctrl.error">
                                <main><i class="fa fa-exclamation-triangle"></i> {{$ctrl.error}}</main>
                            </highlighted>
                        </loading>
                    </div>
                </div>
            </promise-tracker>
        </form>
        `
    })
